import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function YourVisionOurRoadmap() {
  return <section className="relative min-h-screen flex items-center justify-center bg-background overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1399276/img/hero_business_strategy_abstract.png)]" aria-hidden="true">
        <div className="absolute inset-0 bg-primary/60 backdrop-blur-sm" />
      </div>

      {}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-20 text-center">
        <div className="animate-fade-in-up">
          <h1 className="text-[2.75rem] font-bold text-white leading-[1.2] mb-6">
            Your Vision, Our Roadmap
          </h1>
          <p className="text-xl text-white/90 max-w-3xl mx-auto leading-[1.6] mb-4">
            Aran Group specializes in transforming your ideas into market-ready products through strategic planning, expert vendor sourcing, and comprehensive technical support.
          </p>
          <p className="text-lg text-white/80 max-w-2xl mx-auto leading-[1.6] mb-10">
            Our <span className="font-semibold text-white">Product Launch & Roadmap</span> package guides businesses from concept to launch—covering product strategy, vendor relationships, timeline development, and full technical setup.
          </p>
          <Link to="/ProductLaunchRoadmapPage">
            <Button size="lg" className="btn-primary group shadow-strong hover:shadow-strong hover:-translate-y-1 transition-all duration-[250ms]">
              Explore Our Services
              <ArrowRight className="ml-2 size-5 group-hover:translate-x-1 transition-transform duration-[250ms]" />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}